<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoaded" class="row">
            <LoadingScreen :message="'Cargando Información de las horas de Proyectos..'" />
        </div>
        <div v-if="isLoaded">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between">
                                <!-- Sección Izquierda (Título) -->
                                <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                    <h6 class="mb-2 ms-2">Horas de Mis Proyectos Sin Autorizar:</h6>
                                </div>
                                <div>
                                    <button v-if="selectedRecords.length > 0" class="btn btn-success mb-0"
                                        @click="authMultipleRecords">
                                        <i class="fas fa-check me-2"></i>
                                        Autorizar Selección ({{ selectedRecords.length }})
                                    </button>
                                    <button v-if="selectedRecords.length === 0" class="btn btn-success mb-0"
                                        @click="authAll">
                                        <i class="fas fa-check me-2"></i>
                                        Autorizar Todo
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div>
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <button class="btn btn-warning mb-0" @click="changeWeek(-1)">
                                        <i class="bi bi-chevron-left"></i> Anterior
                                    </button>
                                    <h5 class="mb-0">Semana: {{ formatRangeLabel(weekStartDate, weekEndDate) }}</h5>
                                    <button class="btn btn-warning mb-0" @click="changeWeek(1)">
                                        Siguiente <i class="bi bi-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input type="checkbox" @change="toggleSelectAll"
                                                        :checked="allRecordsSelected"
                                                        class="form-check-input border border-secondary">
                                                </th>
                                                <th>Proyecto</th>
                                                <th>Cliente</th>
                                                <th>Colaborador</th>
                                                <th>Total</th>
                                                <th>Regular</th>
                                                <th>Extra</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="!projectTimes.length">
                                                <td colspan="8" class="py-5">
                                                    <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                    <p class="text-muted mb-0">No hay registros pendientes de autorizar
                                                        para este
                                                        período</p>
                                                </td>
                                            </tr>
                                            <tr v-for="record in projectTimes"
                                                :key="`${record.user_id}-${record.project_id}`">
                                                <td>
                                                    <input type="checkbox" :checked="isRecordSelected(record)"
                                                        @change="toggleRecordSelection(record)"
                                                        class="form-check-input border border-secondary">
                                                </td>
                                                <td><b>{{ record.project }}</b></td>
                                                <td>{{ record.client }}</td>
                                                <td><b>{{ record.name }}</b></td>
                                                <td><b>{{ record.total_hours }} hrs</b></td>
                                                <td>{{ record.regular_time }}</td>
                                                <td :class="record.extra_time > 0 ? 'bg-danger text-white' : ''">
                                                    {{ record.extra_time }}
                                                </td>
                                                <td>
                                                    <button class="btn btn-success mb-0"
                                                        @click="authRecordsByProjectUser(record.user_id, record.project_id)">
                                                        <i class="fas fa-check"></i>
                                                    </button>
                                                    <button class="btn btn-secondary mb-0 ms-2"
                                                        @click="showUserDetails(record)">
                                                        <i class="bi bi-info-circle"></i> Ver más
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 mt-4">
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between">
                                <!-- Sección Izquierda (Título) -->
                                <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                    <h6 class="mb-2 ms-2">Horas Autorizadas {{
                                        formatRangeLabel(weekStartDate, weekEndDate) }} :</h6>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div>
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th>Colaborador</th>
                                                <th>Cliente</th>
                                                <th>Proyecto</th>
                                                <th>Total</th>
                                                <th>Regular</th>
                                                <th>Extra</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="!authProjectTimes.length">
                                                <td colspan="6" class="py-5">
                                                    <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                    <p class="text-muted mb-0">No hay registros autorizados en este
                                                        período</p>
                                                </td>
                                            </tr>
                                            <tr v-for="record in authProjectTimes"
                                                :key="`${record.user_id}-${record.project_id}`">
                                                <td><b>{{ record.name }}</b></td>
                                                <td><b>{{ record.client }}</b></td>
                                                <td>{{ record.project }}</td>
                                                <td><b>{{ record.total_hours }} hrs</b></td>
                                                <td>{{ record.regular_time }}</td>
                                                <td>{{ record.extra_time }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { useRouter } from 'vue-router'
import axios from 'axios'
import LoadingScreen from "./components/LoadingScreen.vue"

const router = useRouter()
const token = localStorage.getItem('authToken')
const API_BASE_URL = process.env.VUE_APP_BASE_URL

// Zona horaria CDMX
const TIMEZONE = "America/Mexico_City"

// Inicializar con la semana anterior
const getPreviousWeekDate = () => {
    const date = new Date()
    date.setDate(date.getDate() - 7)
    return date
}

const baseDate = ref(getPreviousWeekDate())

// Obtener fecha CDMX
function getCDMXDate(date = new Date()) {
    const utc = date.toLocaleString("en-US", { timeZone: "UTC" })
    return new Date(
        new Date(utc).toLocaleString("en-US", { timeZone: TIMEZONE })
    )
}

// Obtener lunes de la semana
function getWeekStart(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - ((day + 6) % 7) // Lunes = 1
    return new Date(d.setDate(diff))
}

// Generar semana actual
const weekStartDate = computed(() => getWeekStart(getCDMXDate(baseDate.value)))

const weekEndDate = computed(() => {
    const d = new Date(weekStartDate.value)
    d.setDate(d.getDate() + 6)
    return d
})

function formatToLocalYMD(date) {
    return date.toLocaleDateString("sv-SE", { timeZone: "America/Mexico_City" })
}

// Cambiar semana
const changeWeek = (direction) => {
    const newDate = new Date(baseDate.value)
    newDate.setDate(newDate.getDate() + direction * 7)
    baseDate.value = newDate
    startDate.value = formatToLocalYMD(weekStartDate.value)
    endDate.value = formatToLocalYMD(weekEndDate.value)
    selectedRecords.value = [] // Limpiar selección al cambiar de semana
    fetchProjectsAbstract()
    fetchProjectsAuthAbstract()
}

// Rango de fechas en el título
function formatRangeLabel(start, end) {
    const opciones = {
        weekday: "short",
        day: "numeric",
        month: "short"
    }

    const startStr = start.toLocaleDateString("es-MX", opciones)
    const endStr = end.toLocaleDateString("es-MX", opciones)

    const capitalize = (str) => str.replace(/\b\w/g, c => c.toUpperCase())

    return `${capitalize(startStr)} - ${capitalize(endStr)}`
}

const isLoaded = ref(false)
const startDate = ref(formatToLocalYMD(weekStartDate.value))
const endDate = ref(formatToLocalYMD(weekEndDate.value))

const projectTimes = ref([])
const authProjectTimes = ref([])

// SELECCIÓN MÚLTIPLE

// Array de objetos seleccionados: { user_id, project_id, start_date, end_date }
const selectedRecords = ref([])

// Verificar si un registro está seleccionado
const isRecordSelected = (record) => {
    return selectedRecords.value.some(
        selected => selected.user_id === record.user_id && selected.project_id === record.project_id
    )
}

// Alternar selección de un registro
const toggleRecordSelection = (record) => {
    const index = selectedRecords.value.findIndex(
        selected => selected.user_id === record.user_id && selected.project_id === record.project_id
    )

    if (index > -1) {
        // Ya está seleccionado, remover
        selectedRecords.value.splice(index, 1)
    } else {
        // No está seleccionado, agregar
        selectedRecords.value.push({
            user_id: record.user_id,
            project_id: record.project_id
        })
    }
}

// Verificar si todos los registros están seleccionados
const allRecordsSelected = computed(() => {
    return projectTimes.value.length > 0 &&
        selectedRecords.value.length === projectTimes.value.length
})

// Seleccionar/Deseleccionar todos
const toggleSelectAll = () => {
    if (allRecordsSelected.value) {
        // Deseleccionar todos
        selectedRecords.value = []
    } else {
        // Seleccionar todos
        selectedRecords.value = projectTimes.value.map(record => ({
            user_id: record.user_id,
            project_id: record.project_id
        }))
    }
}


const fetchProjectsAbstract = async () => {
    const body = { start_date: startDate.value, end_date: endDate.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/projects-times-abstract`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        projectTimes.value = response.data
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error)
    }
}

const fetchProjectsAuthAbstract = async () => {
    const body = { start_date: startDate.value, end_date: endDate.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/projects-auth-times-abstract`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        authProjectTimes.value = response.data
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error)
    }
}

// NAVEGAR A DETALLES CON QUERY PARAMS
const showUserDetails = (record) => {
    router.push({
        path: '/project-hours-details',
        query: {
            user_id: record.user_id,
            project_id: record.project_id,
            start_date: startDate.value,
            end_date: endDate.value,
            name: record.name,
            project: record.project
        }
    })
}

// Autorizar UN solo registro

let message = ''

const authRecordsByProjectUser = async (userId, projectId) => {

    message = '¿Estás seguro de autorizar estos registros? Esta acción NO puede deshacerse.'

    if (!confirm(message)) { return; }

    const body = {
        user_id: userId,
        project_id: projectId,
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/auth-project-times`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })

        if (response.status == 200 && response.data.msg) {
            alert(response.data.msg)
        }

        await getData();

    } catch (error) {
        console.error('Error al autorizar registros:', error)
    }
}

const authAll = async () => {

    message = `¿Estás seguro de autorizar TODOS los registros? Esta acción NO puede deshacerse.`
    if (!confirm(message)) { return; }

    selectedRecords.value = projectTimes.value.map(record => ({
        user_id: record.user_id,
        project_id: record.project_id
    }))

    const body = {
        records: selectedRecords.value,
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        // Enviar el arreglo completo al backend
        const response = await axios.post(
            `${API_BASE_URL}/auth-project-times`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )

        if (response.status == 200) {
            alert(response.data.msg || 'Registros autorizados exitosamente')
            selectedRecords.value = [] // Limpiar selección
            await getData();
        }
    } catch (error) {
        console.error('Error al autorizar múltiples registros:', error)
        alert('Ocurrió un error al autorizar los registros')
    }
}

// Autorizar MÚLTIPLES registros
const authMultipleRecords = async () => {

    if (selectedRecords.value.length === 0) {
        alert('Selecciona al menos un registro para autorizar')
        return
    }

    message = `¿Estás seguro de autorizar ${selectedRecords.value.length} registro(s)? Esta acción NO puede deshacerse`

    if (!confirm(message)) { return; }

    const body = {
        records: selectedRecords.value,
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        // Enviar el arreglo completo al backend
        const response = await axios.post(
            `${API_BASE_URL}/auth-project-times`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )

        if (response.status == 200) {
            alert(response.data.msg || 'Registros autorizados exitosamente')
            selectedRecords.value = [] // Limpiar selección
            await getData();
        }
    } catch (error) {
        console.error('Error al autorizar múltiples registros:', error)
        alert('Ocurrió un error al autorizar los registros')
    }
}

const getData = async () => {
    await fetchProjectsAbstract()
    await fetchProjectsAuthAbstract()
    isLoaded.value = true
}

onMounted(async () => {
    await getData()
})
</script>

<style scoped>
.btn:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}
</style>